import { FinancialData, Country } from '@/config'
import { useDark, useLocalStorage, useToggle } from '@vueuse/core'
import { ref } from 'vue'

export const userCountry = useLocalStorage<Country>('rentiqUserCountry', 'Colombia')

const navbarHeight = ref(0)
const sidebarWidth = ref(0)

export default function useGlobalElements() {
  const isDark = useDark()
  const toggleDark = useToggle(isDark)
  const coreFinancialData = ref<FinancialData>()

  return { navbarHeight, sidebarWidth, isDark, coreFinancialData, toggleDark }
}
